// extracted by mini-css-extract-plugin
module.exports = {"primaryColor":"#fdd835","secondaryColor":"#212121"};